export default __webpack_public_path__ + "static/media/FoodDeliveryApp2.ba89d3df.webp";